// src/types/events.ts
import { z } from 'zod';

// Incoming message (server → client) — as-is from cp-core
export const rawIncomingMessageSchema = z.object({
  id: z.union([z.number(), z.string()]).optional(),
  external_id: z.string().optional(),
  text: z.string().optional(),
  type: z.union([z.string(), z.number()]).optional(),
  side: z.enum(['user', 'client', 'bot', 'system']).optional(),
  sent_at: z.union([z.string(), z.number(), z.date()]).optional(),
  file_id: z.union([z.number(), z.string()]).optional(),
  url: z.string().optional(),
  file: z
    .object({
      fileId: z.union([z.number(), z.string()]).optional(),
      name: z.string().optional(),
      type: z.string().optional(),
      url: z.string().optional(),
    })
    .optional(),
  user: z
    .object({
      id: z.string().optional(),
      name: z.string().optional(),
      firstname: z.string().optional(),
      lastname: z.string().optional(),
    })
    .nullable()
    .optional(),
  params: z.unknown().optional(),
});
export type RawIncomingMessage = z.infer<typeof rawIncomingMessageSchema>;

export const rawFilePayloadSchema = z.object({
  id: z.union([z.number(), z.string()]).optional(),
  fileId: z.union([z.number(), z.string()]).optional(),
  name: z.string().optional(),
  type: z.string().optional(),
  url: z.string().optional(),
  size: z.number().optional(),
  // Caption: оператор может приложить подпись к фото/файлу — на бэке
  // (см. cp-core web-client.service.ts) она прокидывается как `text` в payload
  // file-event'а. До F1.7 поле игнорировалось, и подпись не показывалась в виджете.
  text: z.string().optional(),
});
export type RawFilePayload = z.infer<typeof rawFilePayloadSchema>;

export const ackEventSchema = z.object({
  clientExternalId: z.string(),
  externalId: z.string().optional(),
  status: z.enum(['accepted', 'delivered', 'read']),
  at: z.union([z.string(), z.number()]).optional(),
});
export type AckEvent = z.infer<typeof ackEventSchema>;

export const pongMessageSchema = z.object({
  clientExternalId: z.string().optional(),
  externalId: z.string().optional(),
  fileId: z.union([z.number(), z.string()]).optional(),
  name: z.string().optional(),
  type: z.string().optional(),
});
export type PongMessage = z.infer<typeof pongMessageSchema>;
